var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65223 15.5351C7.45787 15.5351 7.26351 15.4669 7.11007 15.3207L5.61658 13.8981C5.31993 13.6156 5.31993 13.1479 5.61658 12.8653C5.91323 12.5827 6.40424 12.5827 6.7009 12.8653L7.65223 13.7715L11.0995 10.4878C11.3962 10.2052 11.8872 10.2052 12.1839 10.4878C12.4805 10.7704 12.4805 11.2381 12.1839 11.5206L8.19439 15.3207C8.05118 15.4669 7.84659 15.5351 7.65223 15.5351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2837 8.76519V13.1479C19.2837 17.5305 17.5307 19.2836 13.148 19.2836H7.8888C3.50613 19.2836 1.75307 17.5305 1.75307 13.1479V7.88866C1.75307 3.506 3.50613 1.75293 7.8888 1.75293H12.2715",
    stroke: "white",
    strokeWidth: 1.3148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2837 8.76519H15.7776C13.148 8.76519 12.2715 7.88866 12.2715 5.25906V1.75293L19.2837 8.76519Z",
    stroke: "white",
    strokeWidth: 1.3148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalreview);
export default __webpack_public_path__ + "static/media/approval review.3b293db7845e3c8023cafa269618cf5f.svg";
export { ForwardRef as ReactComponent };